var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4908 21.704V13.9595H16.4391L16.8805 10.6073H13.4908V8.46701C13.4908 7.49649 13.766 6.83503 15.1873 6.83503L17 6.83421V3.83605C16.6864 3.79534 15.6104 3.7041 14.3586 3.7041C11.7452 3.7041 9.95593 5.26624 9.95593 8.13519V10.6074H7V13.9596H9.95584V21.7041L13.4908 21.704Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook_.80a6b61e22b9c420e6f46ea758403a82.svg";
export { ForwardRef as ReactComponent };